// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueLazyload from 'vue-lazyload'
Vue.use(ElementUI)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/imgs/error.png'),
  loading:  require('./assets/imgs/loading.gif'),
  attempt: 1
})
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js